import { adaptLegacyAssociation, LegacyAssociationContent } from "../../adapters/legacyAssociationAdapter";
import { adaptLegacyBusiness } from "../../adapters/legacyBusinessAdapter";
import { getLegacyBusinessAdapterOptions } from "../../adapters/legacyTranslationAdapter";
import {
  Organization,
  OrganizationKind,
} from "../../domain/organizations/organization.types";
import { associationData } from "../../legacy/data/legacyAssociation.data";
import { businessesData } from "../../legacy/data/legacyBusinesses.data";
import { associationContent } from "../translations";

const associationLocalization: LegacyAssociationContent = {
  slogan: { es: associationContent.es.slogan, en: associationContent.en.slogan },
  description: { es: associationContent.es.description, en: associationContent.en.description },
  history: { es: associationContent.es.history, en: associationContent.en.history },
  mission: { es: associationContent.es.mission, en: associationContent.en.mission },
  vision: { es: associationContent.es.vision, en: associationContent.en.vision },
  galleryCaption: {
    es: associationContent.es.galleryCaption,
    en: associationContent.en.galleryCaption,
  },
};

const institutionalOrganization = adaptLegacyAssociation(associationData, associationLocalization);

const confirmedBusinessKinds: Readonly<Record<string, OrganizationKind>> = {
  "lacteos-don-juan": "hybrid",
  "cafe-la-marcela": "product-business",
  "api-zaid": "product-business",
  "api-g-apiarios-gil": "hybrid",
  "finca-zamora-fallas": "hybrid",
  "mieles-santa-lucia": "product-business",
  "pasteleria-reposteria-jessy": "hybrid",
};

const businessOrganizations = businessesData.map((business) =>
  adaptLegacyBusiness(business, {
    ...getLegacyBusinessAdapterOptions(business),
    kind: confirmedBusinessKinds[business.id],
  })
);
const organizations: readonly Organization[] = Object.freeze([
  institutionalOrganization,
  ...businessOrganizations,
]);

export const getAllOrganizations = (): readonly Organization[] => organizations;

export const getOrganizationById = (id: string): Organization | undefined =>
  organizations.find((organization) => organization.id === id);

export const getInstitutionalOrganization = (): Organization => institutionalOrganization;

export const getBusinessOrganizations = (): readonly Organization[] => businessOrganizations;

export const getOrganizationsWithServices = (): readonly Organization[] =>
  businessOrganizations.filter((organization) =>
    Boolean(organization.serviceCatalog?.services.length)
  );

export const organizationExists = (id: string): boolean =>
  organizations.some((organization) => organization.id === id);
